export default __webpack_public_path__ + "static/media/u4-ubahn-neubauprojekte-wien.100d299c.svg";